import { deleteApi, get } from "../GenericServices";

const ProjectDocument = {
  deleteDocumentContractualRevenue: (id) => {
    return deleteApi(`project-document/${id}`);
  },
  downloadDocumentContractualRevenue: (id) => {
    return get(`project-document/${id}/download`, {}, "blob");
  },
};

export default ProjectDocument;
